import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { FileStorePluginApiRef } from './api/FileStorePluginApi';
import { FileStorePluginClient } from './api/FileStorePluginClient';
import { rootRouteRef } from './routes';

export const fileStorePluginPlugin = createPlugin({
  id: 'file-store-plugin',
  routes: {
    root: rootRouteRef,
  },

  apis: [
    createApiFactory({
      api: FileStorePluginApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) =>
        new FileStorePluginClient({ discoveryApi, identityApi }),
    }),
  ],
});

export const FileStorePluginPage = fileStorePluginPlugin.provide(
  createRoutableExtension({
    name: 'FileStorePlugin',
    component: () => import('./components/MainPage').then(m => m.MainPage),
    mountPoint: rootRouteRef,
  }),
);
